<template functional>
  <div>
    <span class="block whitespace-no-wrap">{{ $options.methods.getNetPrice(props) | price('EUR') }} <span class="inline-block w-10">Netto</span></span>
    <span class="block whitespace-no-wrap">{{ $options.methods.getGrossPrice(props, {
      purchasingPrice: $options.methods.getPurchasingPrice(props),
      isDifferentialTaxed: $options.methods.isDifferentialTaxed(props),
    }) | price('EUR') }} <span class="inline-block w-10">Brutto</span></span>
  </div>
</template>

<script>
import get from 'lodash/get'
import { netToGross } from '@/helpers/utils'

export default {
  name: 'MiaCarSearchDatatableGrossNetPriceColumn',

  props: {
    row: {
      type: Object,
      default() {
        return {}
      }
    },

    column: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  methods: {
    isDifferentialTaxed({ row, column }) {
      const callback = get(column, 'meta.isDifferentialTaxed', () => false)

      return callback(row)
    },

    getPurchasingPrice({ row, column }) {
      return get(
        row,
        get(column, 'meta.pricePurchasedField', null)
      )
    },

    getNetPrice({ row, column }) {
      return row[column.field] === null ? 0 : row[column.field]
    },

    getGrossPrice({ row, column }, { purchasingPrice, isDifferentialTaxed }) {
      return netToGross(row[column.field], purchasingPrice, isDifferentialTaxed)
    }
  }
}
</script>
